<template>
    <v-app>
        <app-navigation></app-navigation>

        <app-bar></app-bar>

        <v-content>
            <router-view></router-view>
        </v-content>

        <flash-message></flash-message>
    </v-app>
</template>

<script>
import AppNavigation from '@/components/dashboard/AppNavigation'
import AppBar from '@/components/dashboard/AppBar'
import FlashMessage from '@/components/dashboard/FlashMessage'

export default {
    components: {
        AppNavigation,
        AppBar,
        FlashMessage,
    }
}
</script>
